module.exports = __webpack_public_path__ + "static/image1-256214ea6236108d4e808a2ff43d0857.jpg";